import NaptimeResource from './NaptimeResource';

class GdprSettings extends NaptimeResource {
  static RESOURCE_NAME = 'gdprSettings.v1';
}

export default GdprSettings;
